// extracted by mini-css-extract-plugin
export default {"infoText":"HowWork_infoText__3q16j","cardWrap":"HowWork_cardWrap__qYM3h","dots":"HowWork_dots__JGe+H"};